import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VenuesService {
  private httpClient = inject(HttpClient);

  constructor() { }

  myVenues() {
    return this.httpClient.get<any>('api_endpoint' + `/venue/my-venues`).pipe(
      map(res => res.data)
    );
  }

  create(venueObject) {
    return this.httpClient.post<any>('api_endpoint' + `/venue/create`, { venueObject }).pipe(
      map(res => res.data)
    );
  }

  addToTournament(_tournamentId: string, _venueId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/venue/tournament/${_tournamentId}/add-venue`, { _venueId }).pipe(
      map(res => res.data)
    );
  }

  removeFromTournament(_tournamentId: string, _venueId: string) {
    return this.httpClient.post<any>('api_endpoint' + `/venue/tournament/${_tournamentId}/remove-venue`, { _venueId }).pipe(
      map(res => res.data)
    );
  }

  getLocations(_venueId: string) {
    return this.httpClient.get<any>('api_endpoint' + `/venue/${_venueId}`).pipe(
      map(res => res.data)
    );
  }
}
